module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "ctbm"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_VII",
      "title": "VII"
    }
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1"
    }
  }, [_vm._v("1. Making Law Intelligible in Comparative Context")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Brian P. Owensby and Richard J. Ross")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("PART I. MIS-DIALOGUES, CODE SWITCHING, AND MIXING LANGUAGES OF LAW")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Dialoguing with Barbarians: What Natives Said and How Europeans Responded in Late-Seventeenth- and Eighteenth-Century Portuguese America")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Tamar Herzog")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Defending and Defrauding the Indians: John Wompas, Legal Hybridity, and the Sale of Indian Land")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Jenny Hale Pulsipher")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. “Since We Came out of This Ground”: Iroquois Legal Arguments at the Treaty of Lancaster")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Craig Yirush")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. “"), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Ynuvaciones malas e rreprouadas")]), _vm._v("”: Seeking Justice in Early Colonial Pueblos de Indios")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Karen B. Graubart")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("PART II. AT THE BOUNDARIES OF DIFFERING CONCEPTIONS OF JUSTICE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. “Darling Indians” and “Natural Lords”: Virginia’s Tributary Regime and Florida’s Republic of Indians in the Seventeenth Century")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Bradley Dixon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Covering Blood and Graves: Murder and Law on Imperial Margins")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Nancy O. Gallman and Alan Taylor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_viii",
      "title": "viii"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. “Sovereignty Has Lost Its Rights”: Liberal Experiments and Indigenous Citizenship in New Granada, 1810–1819")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Marcela Echeverri")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("PART III. CONCLUDING PERSPECTIVES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. In Defense of Ignorance: Frameworks for Legal Politics in the Atlantic World")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Lauren Benton")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Intelligibility or Incommensurability?")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Daniel K. Richter")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/abouttheeditor",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("About the Editors")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contributors",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("About the Contributors")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Index")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0